export default __webpack_public_path__ + "static/media/Buffalo Wings_ proportioned_170.25cab753.jpg";